@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.wrapper {
  padding: 20px;
}

.code-field {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  margin-bottom: 10px;

  > label {
    font-size: 14px;
    font-weight: @bold;
  }

  > input {
    margin-top: 5px;
    height: 40px;
    max-width: 200px;
    font-size: 16px;
    font-weight: @normal;
  }
}

.error {
  color: @phone-verify--error--text-color;
  font-size: 13px;
}

.resend {
  font-size: 14px;
  height: 20px;
  margin-top: 5px;
}
